


























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// components
import SelectChannelModal from "@/components/channels/modals/SelectChannelModal.vue";
import SelectChannelGroupModal from "@/components/channels/modals/SelectChannelGroupModal.vue";
// types
import i18n from "@/i18n";
import { Content, ContentType, ContentStatusEnum } from "@/services/backgrounds/types";
import { Guid } from "guid-typescript";
import { contentFields } from "@/components/backgrounds/fields/contentFields";
// validation
import validate from "@/directives/validate";
import { addContentValidators, removeContentValidators } from "@/components/backgrounds/validators";

@Component({
    components: {
        "select-channel-modal": SelectChannelModal,
        "select-channel-group-modal": SelectChannelGroupModal
    },
    directives: {
        validate
    }
})
export default class BackgroundContent extends Vue {
    @Prop() content!: Content[];
    @Prop() collapseState!: boolean;

    // local state
    localCollapseState = true;
    localContent = [] as Content[];
    fields = contentFields;
    validators = {};
    contentStatusEnum = ContentStatusEnum;
    // Watchers
    @Watch("content")
    onPropertyChanged(value: boolean, oldValue: any) {
        this.localContent = this.content;
        if (this.localContent.length > 0) { }
        this.localContent.forEach(x => {
            addContentValidators(this.validators, x.id);
        });
    }

    // lifecycle hooks
    mounted() {
        this.localCollapseState = this.collapseState;
    }
    // computed

    // methods
    addChannel() {
        (this.$refs.selectChannelModal as any).open(true);
    }

    addChannelGroup() {
        (this.$refs.selectChannelGroupModal as any).open(true);
    }

    addContent(contentId: string, contentName: string, contentType: ContentType) {
        if (!this.localContent) { this.localContent = [] as Content[]; }
        const maxLayer = Math.max.apply(Math, this.localContent.map(function (o) { return o.layer; }));
        const content = {} as Content;
        content.id = Guid.create().toString();
        content.contentId = contentId;
        content.name = contentName;
        content.type = contentType;
        content.typeName = this.getContentTypeName(content.type);
        content.layer = maxLayer > 0 ? maxLayer + 1 : 100;
        content.status = this.contentStatusEnum.Active;

        addContentValidators(this.validators, content.id);
        this.localContent.push(content);
    }

    getContentTypeName(type: ContentType) {
        return i18n.t(`background.contentTypes.${ContentType[type].toLowerCase()}`).toString();
    }

    deleteContent(id: string) {
        const item = this.localContent.find(x => x.id === id);
        if (!item) {
            return;
        }
        this.localContent.splice(this.localContent.indexOf(item), 1);
        this.$nextTick(() => {
            removeContentValidators(this.validators, item.id);
        });
    }

    // events && callbacks
    channelSelected(channels: any) {
        channels.forEach((channel: any) => {
            this.addContent(channel.id, channel.name, ContentType.Channel);
        });
    }

    channelGroupSelected(channelGroups: any) {
        channelGroups.forEach((channelGroup: any) => {
            this.addContent(channelGroup.id, channelGroup.name, ContentType.ChannelGroup);
        });
    }

    emitData() {
        // deep copy to avoid binding
        this.$emit("contentUpdated", JSON.parse(JSON.stringify(this.localContent)));
    }

    setState(state: boolean) {
        if (this.localCollapseState === state) return;

        this.localCollapseState = state;
        this.$emit("componentStateChanged", { name: "BackgroundContent", state: state });
    }

    goToContentRoute(model: Content) {
        if (model.type === ContentType.Channel) {
            return {
                name: "updatechannel",
                params: { channelId: model.contentId }
            };
        }
        return {
            name: "UpdateChannelGroup",
            params: { channelGroupId: model.contentId }
        };
    }

    toggleActive(item: Content) {
        if (item.status === this.contentStatusEnum.Active) {
            item.status = this.contentStatusEnum.Disabled;
        } else {
            item.status = this.contentStatusEnum.Active;
        }
    }
}
